import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ResponsePageWrapper from '../../components/layouts/ResponsePageWrapper';
import Button from '../../components/misc/Button';
import EventOverview from '../../components/overviews/EventOverview';
import { eventService } from '../../services';
import { PersonalEvent as Event } from '../../types/event';

export default function PaidPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const location = useLocation();
  const state = location.state as { eventId?: number } | undefined;

  const [event, setEvent] = useState<Event | undefined>(undefined);
  const linkId = params.get('id');
  const queryEventId = params.get('eventId');
  const redirectStatus = params.get('redirect_status');
  const isFailed = redirectStatus === 'failed';

  useEffect(() => {
    if (state?.eventId) {
      eventService
        .getEvent(Number(state.eventId))
        .then((e) => setEvent(e))
        .catch(() => setEvent(undefined));
    } else if (queryEventId) {
      eventService
        .getEvent(Number(queryEventId))
        .then((e) => setEvent(e))
        .catch(() => setEvent(undefined));
    } else if (linkId) {
      eventService
        .getEventInviteWithToken(linkId as string)
        .then((e) => setEvent(e))
        .catch(() => {
          setEvent(undefined);
        });
    }
  }, [state?.eventId, queryEventId, linkId]);

  return (
    <ResponsePageWrapper>
      {event && (
        <ResponsePageWrapper.SidePanel>
          <EventOverview event={event} />
        </ResponsePageWrapper.SidePanel>
      )}

      <div className="flex flex-col gap-4">
        <h2 className={`text-2xl font-semibold ${isFailed ? 'text-danger-700' : 'text-primary-900'}`}>
          {isFailed ? t('page.paid.failed.title') : t('page.paid.title')}
        </h2>
        <div className="text-secondary-600">{isFailed ? t('page.paid.failed.message') : t('page.paid.message')}</div>

        <div className="flex h-full w-full flex-1 justify-end">
          <Button variant="primary" onClick={() => navigate('/')}>
            {t('general.close')}
          </Button>
        </div>
      </div>
    </ResponsePageWrapper>
  );
}
